import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import api from '../../services/api';
import getClientConfig from '../../utils/get-client-config';

const extractParams = (query) => {
  // APP-4055 12-19-2023 could not use URLSearchParams as it strips `+` from emails
  const params = query.slice(1).split('&');
  const extractedParams = {};
  params.forEach((param) => {
    const [key, value] = param.split('=');
    extractedParams[key] = value;
  });
  return extractedParams;
};

const attributeFriendlyNameMap = {
  email: 'Email',
  phone_number: 'Phone Number',
};

export default function CheckVerificationModal(props) {
  const {
    onClose, userAccount, attributeName,
  } = props;
  const attributeFriendlyName = attributeFriendlyNameMap[attributeName];
  const urlParams = extractParams(window.location.search);
  const { code, [attributeName]: value } = urlParams;
  const [verificationStatus, setVerificationStatus] = useState('Verifying...');

  useEffect(() => {
    const errorMessages = {
      ExpiredCodeException: 'Verification link has expired. Please request a new link.',
      CodeMismatchException: 'Verification link is invalid.',
      LimitExceededException: 'Please try again later.',
    };
    const isVerified = async () => {
      if (!value) {
        return false;
      }

      if (userAccount[attributeName] !== value) {
        setVerificationStatus(`${attributeFriendlyName} could not be verified. Please ensure you are logged in to the correct account.`);
        return false;
      }

      if (userAccount[`${attributeName}_verified`]) {
        setVerificationStatus(`${attributeFriendlyName} is already verified.`);
        return true;
      }

      const result = await api('CheckVerification', {
        accessToken: userAccount.accessToken,
        attributeName,
        code,
      });

      if (result?.$metadata?.httpStatusCode === 200) {
        setVerificationStatus(`${attributeFriendlyName} verified successfully!`);
        await getClientConfig({ forceRefresh: true });
        return true;
      }
      console.error(result.errorType, result.errorMessage);
      setVerificationStatus(`${attributeFriendlyName} could not be verified. ${errorMessages[result.errorType] || ''}`);
      return false;
    };
    isVerified();
  }, [code, value, userAccount, attributeName, attributeFriendlyName]);

  return (
    <Modal isOpen>
      <ModalHeader>
        {attributeFriendlyName}
        {' '}
        Verification
      </ModalHeader>
      <ModalBody>
        <p>
          {verificationStatus}
        </p>

      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={onClose}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
